export default __webpack_public_path__ + "static/media/eric-duval.d768e248.jpg";